import Service from 'react-reservice';

import experienceApi, { IRegisterDemoAccountParams } from '@webtrader/core/api/experienceDemo';
import { IApiError } from '@webtrader/core/request/api';
import { ECommonResponseCode, mapResponseCodeToMessage } from '@webtrader/core/request/message';

interface IExperienceDemoCreationServiceContext {
  loading: boolean;
  isDisabled: boolean;
}

const defaultContext: IExperienceDemoCreationServiceContext = {
  loading: false,
  isDisabled: true
};

class ExperienceDemoCreationService extends Service<IExperienceDemoCreationServiceContext> {
  constructor() {
    super();
    this.context = {
      ...defaultContext
    };
  }

  public submitForm = async (params: IRegisterDemoAccountParams) => {
    try {
      this.context.loading = true;
      const { result, code } = await experienceApi.registerDemoAccount(params);
      if (code === ECommonResponseCode.OK && result) {
        return {
          success: true,
          message: 'Success',
          result
        };
      }
      return {
        success: false,
        message: 'An error occurred'
      };
    } catch (error) {
      const { code, message } = error as IApiError;
      return {
        success: false,
        message: mapResponseCodeToMessage(code, message)
      };
    } finally {
      this.context.loading = false;
    }
  };
}

export const experienceDemoCreationService = new ExperienceDemoCreationService();
